module.exports = __webpack_public_path__ + "static/media/motor_picture1.1d6865eb.jpg";